import React, { useEffect } from "react";
import { useArrayContext } from "../../../state/ArrayContext";
import { useSiteContext } from "../../../state/SiteContext";
import { MetadataRequest } from "../../../shared/models/metadata-request.model";
import { useFilterContext } from "../../../state/FilterContext";
import { Metadata } from "../../../shared/models/metadata.model";
import { services } from "../../../globals";
import { mapMetadataToItem } from "../../../shared/utils/source-item.utils";
import { useFileContext } from "../../../state/FileContext";

interface SimilarQueryProps {
    contentType?: string;
    /** When true, base file paths (Site.files) are included in search results. Default false. */
    includeBasefiles?: boolean;
}

/***
 * Array source that returns the result of searching for similar files,
 * using the current filter state and the current file.
 * 
 * Params:
 *      contentType: The content type to search for
 */
export const SimilarQuery = React.memo(function SimilarQuery({ contentType, includeBasefiles = false }: SimilarQueryProps): React.ReactElement {
    const { setArray } = useArrayContext();
    const { siteState } = useSiteContext();
    const { filterState } = useFilterContext();
    const { fileState } = useFileContext();

    useEffect(() => {
        let isMounted = true;
        const fetchData = async () => {
            if (siteState.site?.name) {
                const request: MetadataRequest = { ...filterState };
                contentType && (request.contentType = contentType);
                if (includeBasefiles) request.includeBasefiles = true;
                const searchlist: Array<Metadata> = await services.search.searchSimilar(
                    siteState.site.name,
                    fileState.metadata?._id?.str || "",
                    request,
                );
                const result = searchlist.map((hit, ix) => {
                    return { ...mapMetadataToItem(hit), position: ix + 1 };
                });
                if (isMounted) {
                    setArray(result);
                }
            }
        };
        fetchData();
        return () => { isMounted = false; };
    }, [siteState, filterState, fileState, contentType, includeBasefiles, setArray]);

    return <></>;
});